"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const UserIcon_1 = __importDefault(require("mdi-react/UserIcon"));
const react_1 = __importStar(require("react"));
const bs_1 = require("react-icons/bs");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const filter_svg_1 = __importDefault(require("../../../assets/images/filter.svg"));
const RangePickerComponent_1 = __importDefault(require("../../../components/rangePickerComponent/RangePickerComponent"));
const underline_1 = __importDefault(require("../../../components/underline"));
const Properties_1 = require("../../../hooks/Properties");
const suitesReserve_1 = require("../../../redux/actions/suitesReserve");
const RoutesPaths_1 = require("../../../routes/RoutesPaths");
require("./SideMenu.scss");
const SideMenuStyles_1 = require("./SideMenuStyles");
const SelectGuestComponent_1 = __importDefault(require("../../../components/formComponents/selectGuestComponent/SelectGuestComponent"));
const constants_1 = require("../../../assets/constants/constants");
const rangePickerSideMenuName = 'range-menu';
const guestsMenuName = 'guestsMenu';
const SideMenu = ({ queryURL, isClosed, setIsClosed }) => {
    const history = (0, react_router_dom_1.useHistory)();
    const { Panel } = antd_1.Collapse;
    const [form] = antd_1.Form.useForm();
    const propContext = (0, Properties_1.useProperties)();
    const [loadMenu, setLoadMenu] = (0, react_1.useState)({});
    const [propertyText, setPropertyText] = (0, react_1.useState)('Selecione uma localização');
    const [categoryText, setCategoryText] = (0, react_1.useState)('Selecione uma categoria');
    const [rangePickerInitialValues, setRangePickerInitialValues] = (0, react_1.useState)(null);
    const [initialQtyGuests, setInitialQtyGuests] = (0, react_1.useState)(constants_1.DEFAULT_GUESTS_PER_ROOM);
    const dispatch = (0, react_redux_1.useDispatch)();
    const requestLoadMenu = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (propContext.properties && propContext.properties.length > 0) {
            const groupProperties = (_a = propContext.properties) === null || _a === void 0 ? void 0 : _a.map(prop => {
                return {
                    label: prop.name,
                    value: prop.propId,
                };
            });
            const stateLoadMenu = {
                properties: groupProperties,
            };
            setLoadMenu(stateLoadMenu);
        }
    }), [propContext.properties]);
    (0, react_1.useEffect)(() => {
        try {
            if (!queryURL) {
                return;
            }
            const queryObj = JSON.parse(JSON.stringify(queryURL));
            let propertyString = '';
            if (queryObj.property && queryObj.property.length) {
                queryObj.property.forEach((value, index) => {
                    if (index) {
                        propertyString += ', ';
                    }
                    propertyString += value;
                });
            }
            else {
                setPropertyText('Selecione uma localização');
            }
            let categoryString = '';
            if (queryObj.category && queryObj.category.length) {
                queryObj.category.forEach((value, index) => {
                    if (index) {
                        categoryString += ', ';
                    }
                    categoryString += value;
                });
            }
            else {
                setCategoryText('Selecione uma categoria');
            }
            if (queryObj.selectedDate) {
                const { selectedDate } = queryObj;
                const initialDate = selectedDate[0] ? selectedDate[0] : undefined;
                const finalDate = selectedDate[1] ? selectedDate[1] : undefined;
                setRangePickerInitialValues({
                    before: initialDate,
                    after: finalDate,
                });
            }
            let guests = constants_1.DEFAULT_GUESTS_PER_ROOM;
            if (queryObj && queryObj.guests) {
                guests = queryObj.guests;
            }
            setInitialQtyGuests(guests);
            form.setFieldsValue(queryObj);
        }
        catch (err) {
            console.log(`ERRO:${err}`);
        }
    }, [form, queryURL]);
    const handleFields = (0, react_1.useCallback)((changedFieldName = '', cleanFields = []) => {
        const formValues = form.getFieldsValue();
        let propertyString = formValues.property ? `property=${JSON.stringify(formValues.property)}` : 'property=[]';
        let categoryString = formValues.category ? `&category=${JSON.stringify(formValues.category)}` : '';
        let selectedDateString = '';
        const initialDate = formValues[`initialDate-${rangePickerSideMenuName}`];
        const finalDate = formValues[`finalDate-${rangePickerSideMenuName}`];
        const selectedDate = [initialDate, finalDate];
        if (initialDate || finalDate) {
            selectedDateString = `&selectedDate=${JSON.stringify(selectedDate)}`;
        }
        // caso não tenha selecionado a data final, apaga a data inicial para fazer a busca
        if (changedFieldName !== 'rangePicker' && !finalDate) {
            setRangePickerInitialValues(null);
            selectedDateString = '';
        }
        const guests = formValues[`${guestsMenuName}Guests`];
        let guestsString = '';
        if (guests) {
            guestsString = `&guests=${guests}`;
        }
        cleanFields.forEach((fieldName) => {
            switch (fieldName) {
                case 'property':
                    propertyString = '';
                    break;
                case 'category':
                    categoryString = '';
                    break;
                case 'selectedDate':
                    selectedDateString = '';
                    break;
                case 'guests':
                    guestsString = '';
                    break;
            }
        });
        dispatch((0, suitesReserve_1.setBuildingName)({ showThis: '' }));
        history.push(`${RoutesPaths_1.routesPaths.bookSuite}?${propertyString}${categoryString}${selectedDateString}${guestsString}`);
    }, [form, history]);
    (0, react_1.useEffect)(() => {
        if (Object.entries(loadMenu).length === 0 || loadMenu.properties === undefined) {
            requestLoadMenu();
        }
    }, [loadMenu, requestLoadMenu]);
    (0, react_1.useEffect)(() => {
        form.submit();
    }, [form]);
    const dateTimeStringSP = new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
    const dateStringSP = dateTimeStringSP.split(' ')[0].split('/');
    const initialDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
    const finalDate = new Date(Number(dateStringSP[2]), Number(dateStringSP[1]) - 1, Number(dateStringSP[0]));
    finalDate.setFullYear(finalDate.getFullYear() + 1);
    finalDate.setDate(finalDate.getDate() - 1);
    return (react_1.default.createElement("div", { className: `SideMenu ${isClosed ? 'closed' : ''}` },
        react_1.default.createElement("div", { className: `SideMenuHeader ` },
            react_1.default.createElement("div", null,
                react_1.default.createElement(SideMenuStyles_1.TitleMenu, { locale: "" },
                    react_1.default.createElement("span", null, "Su\u00EDtes ")),
                react_1.default.createElement(underline_1.default, null)),
            react_1.default.createElement("div", { className: `menuHamburger `, onClick: () => setIsClosed(oldState => !oldState) },
                react_1.default.createElement("img", { src: filter_svg_1.default, alt: "" }))),
        react_1.default.createElement(SideMenuStyles_1.Container, { isClosed: isClosed },
            react_1.default.createElement(antd_1.Form, { form: form },
                react_1.default.createElement(RangePickerComponent_1.default, { form: form, name: rangePickerSideMenuName, unavailableDates: [], initialDate: initialDate.toLocaleDateString('pt-BR'), finalDate: finalDate.toLocaleDateString('pt-BR'), initialLabel: "Entrada", finalLabel: "Sa\u00EDda", initialPlaceholder: "Selecione uma data", finalPlaceholder: "Selecione uma data", placement: "right", onChange: actionName => {
                        // Não faz a busca quando preenche a data inicial, apenas quando limpa ou preenche a fianl
                        if (actionName !== 'initalDateChange') {
                            handleFields('rangePicker');
                        }
                    }, initialValues: rangePickerInitialValues }),
                react_1.default.createElement(SideMenuStyles_1.Label, null, "Localiza\u00E7\u00E3o"),
                react_1.default.createElement(SideMenuStyles_1.CollapseStyled, { expandIconPosition: "right", expandIcon: () => react_1.default.createElement(bs_1.BsCaretDownFill, null), bordered: false },
                    react_1.default.createElement(Panel, { key: 1, header: react_1.default.createElement("div", { className: "category-string" }, propertyText) },
                        react_1.default.createElement("div", { className: "clean-filter", onClick: () => handleFields('property', ['property']) }, "Limpar filtro"),
                        react_1.default.createElement(antd_1.Form.Item, { initialValue: undefined, name: "property" },
                            react_1.default.createElement(SideMenuStyles_1.CheckBoxGroup, { options: loadMenu && loadMenu.properties, onChange: handleFields })))),
                react_1.default.createElement("div", { className: "guest-component noselect" },
                    react_1.default.createElement("div", { className: "guest-title" }, "Su\u00EDtes"),
                    react_1.default.createElement("div", { className: "guest-field" },
                        react_1.default.createElement(UserIcon_1.default, null),
                        react_1.default.createElement(SelectGuestComponent_1.default, { form: form, initialQtyGuests: initialQtyGuests, baseName: guestsMenuName, onChange: handleFields })))))));
};
exports.default = SideMenu;
